import { createAsyncThunk } from '@reduxjs/toolkit';
import { storeResources } from 'store/resources';
import { getMicrosoftSettings } from 'services/auth';
import { IMicrosoftSettings } from 'services/auth/types';

export const ThunkGetMicrosoftSettings = createAsyncThunk<IMicrosoftSettings>(
  `${storeResources.AUTH}/getMicrosoftSettings`,
  () => getMicrosoftSettings().then(r => r.data),
);
